'use client';

import React from 'react';
import { useFormContext } from 'react-hook-form';
import FormSection from './FormSection';
import FormField from './FormField';
import RadioOption from './RadioOption';
import type { RSVPFormData } from './RSVPPageClient';

const attendanceOptions = [
  { value: 'engagement', label: '💍 Engagement — 31 December' },
  { value: 'wedding', label: '❤️ Wedding — 4 January' },
  { value: 'both', label: '💍❤️ Both Engagement & Wedding' },
  { value: 'neither', label: "Unfortunately, I won't be able to attend" },
];

const certaintyOptions = [
  { value: 'confirmed', label: 'Confirmed' },
  { value: 'likely', label: 'Most likely' },
  { value: 'unsure', label: 'Not completely sure yet' },
];

export default function Section2RSVP() {
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext<RSVPFormData>();

  const attendance = watch('attendance');
  const showCertainty = attendance && attendance !== 'neither';

  return (
    <FormSection number={2} title="Your #Vimi RSVP" animate={false}>
      <FormField
        label="Which celebration(s) will you be attending?"
        required
        error={errors.attendance?.message}
      >
        <div className="grid gap-2 mt-1">
          {attendanceOptions.map((opt) => (
            <RadioOption
              key={`attendance-${opt.value}`}
              name="attendance"
              value={opt.value}
              label={opt.label}
              registerProps={register('attendance', {
                required: 'Please select which events you will attend',
              })}
            />
          ))}
        </div>
      </FormField>

      {showCertainty && (
        <FormField label="How certain is your RSVP?">
          <div className="grid gap-2 mt-1">
            {certaintyOptions.map((opt) => (
              <RadioOption
                key={`certainty-${opt.value}`}
                name="certainty"
                value={opt.value}
                label={opt.label}
                registerProps={register('certainty')}
              />
            ))}
          </div>
        </FormField>
      )}
    </FormSection>
  );
}